<template>
  <div class="big">
            <van-nav-bar
      @click-left="$router.go(-1)"
      left-arrow
      left-text="返回"
       />
    <div class="card">
        <div class="title">
          <span style="height:0.5rem; padding:0.1rem;background:#37A5DA;margin-right:0.2rem">&nbsp;</span>
          订阅信息
        </div>
        <div class="list">
          <div class="list-item">
            <span>产品名称：</span>
            <span style="color:#1A1A1A">{{ query.productName }}   ￥{{query.productPrice / 100}}
              <!-- <span v-if="query.productName=='月卡'">1个月<span style="margin-left:0.45rem">￥10</span></span>
              <span v-if="query.productName=='半年卡'">6个月<span style="margin-left:0.45rem">￥55</span></span>
              <span v-if="query.productName=='年卡'">12个月<span style="margin-left:0.45rem">￥100</span></span> -->
            </span>
          </div>
          <div class="list-item">
            <span>订阅人数：</span>
            <span style="color:#1A1A1A">{{ query.packageName }}
              <span style="margin-left:0.45rem" v-if="query.type==0">{{ query.discount == 1 ? '原价' : query.discount * 10 + '折' }}</span>
            </span>
          </div>
          <div class="list-item">
            <span>购买人：</span> <span style="color:#1A1A1A"><span style="margin-right:0.45rem">{{ query.userName }}</span>{{ query.userMobile }}</span>
          </div>
          <!-- <div class="list-item">
            <span>手机号：</span> <span></span>
          </div> -->
          <div class="list-item" v-if="query.child">
            <span>孩子信息：</span>
            <div class="flex flex-1">
              <span style="color:#1A1A1A">
                {{ query.child.name }}
                <span style="margin: 0 0.45rem">{{query.child.schoolName}}</span>
                {{ query.child.className }}
              </span>
              <br/> 
              <span v-if="query.payTime&&query.type==1" class="dueTime">服务已订阅</span>
              <span v-else-if="query.payTime" class="dueTime">订阅到期时间：{{ getDateYMD(query.dueDate) }}</span>
              <span v-else  class="dueTime">订阅待开通</span>
            </div>
          </div>
        </div>
      </div>
    <div class="card" style="margin-bottom:4rem;padding-bottom:0">
      <div class="card-title ">
        <span class="orderName">&nbsp;</span>
          修改订阅人员
      </div>
      <div class="bind-list">
        <van-row type="flex" align="center" style="margin-bottom: 0.6rem;">
          <van-col :span="9">
            <div class="bind-list-title">已订阅人员</div>
          </van-col>
          <van-col :span="10">
            <div class="bind-list-title"></div>
          </van-col>
          <van-col :span="5">
            <div class="bind-list-title"></div>
          </van-col>
        </van-row>
        <van-row
          type="flex"
          align="center"
          v-for="(item, index) in addPersonData"
          :key="index"
          style="margin-left:2rem;color:#1A1A1A;font-size:0.85rem;height:2.5rem;" >
          <!-- item.bandingUserId&&!item.new|| -->
          <van-col :span="8" v-if="item.bindingStatus=='已绑定'"> 
            {{item.bandingUserName}} 
          </van-col>
          <van-col :span="8" class="bService" v-else >
            <van-field v-model="item.bandingUserName" @input.native="listenEdPerson(item,index)"  placeholder="填写姓名" /> 
          </van-col>
          <!-- <van-col :span="10" class="bService" v-else >
            <van-field v-model="item.bandingUserName"  placeholder="填写姓名" /> 
          </van-col> -->
          <!-- item.bandingUserId&&!item.new|| -->
          <van-col :span="item.isPayOrder!=1?'10':'12'" v-if="item.bindingStatus=='已绑定'" :style="item.isPayOrder!=1?'margin-left:0.5rem':''" >
            {{item.bandingUserPhone}}
          </van-col>
          <!-- <van-col :span="13" class="bPhone" v-else-if="item.new ||item.bindingStatus=='未绑定'" style="margin-left:0.5rem;">
               <van-field v-model="item.bandingUserPhone" type="tel" placeholder="填写手机号" maxlength='11'  />
          </van-col> -->
          <van-col :span="10" class="bPhone" v-else style="margin-left:0.5rem;">
               <van-field v-model="item.bandingUserPhone" type="tel" placeholder="填写手机号" @input.native="listenEdPerson(item,index)" maxlength='11'  />
          </van-col>
          <van-col :span="4" v-show="item.isPayOrder!=1">
            <div class="operate">
              <div>
                <img src="@/assets/del.png"
                  alt=""
                  @click="delPersonData(item, index)" />
              </div>
            </div>
          </van-col>
        </van-row> 
        <van-row type="flex" align="center" style="margin-bottom: 0.6rem;margin-top:0.7rem" >
          <van-col :span="8">
            <div class="bind-list-title">未订阅人员</div>
          </van-col>
          <van-col :span="10">
            <div class="bind-list-title"></div>
          </van-col>
          <van-col :span="4">
            <div class="bind-list-title"></div>
          </van-col>
        </van-row> 
      <van-checkbox-group
        style="width: 100%;"
        v-model="checkbox" >
        <van-row
          type="flex"
          align="center"
          v-for="(item, index) in notPersonData"
          :key="index"
          style="margin-left:1rem;color:#1A1A1A;font-size:0.85rem;height:1.9rem"
        >
         <van-col :span="4">
            <van-checkbox :name="item" shape="square" ref="checkboxes" @click="handleChangeChecked(item)" style="width:100%"> 
            </van-checkbox>
         </van-col>
        <van-col :span="7">
            <!-- <van-checkbox :name="item" shape="square" ref="checkboxes" @click="handleChangeChecked(item)" style="width:100%">  -->
              <!-- {{item.bandingUserName}} -->
              <van-field v-model="item.bandingUserName" :readonly="item.bindingStatus=='已绑定'" placeholder="填写姓名" style="font-size:0.85rem;padding-left:0.15rem" />
            <!-- </van-checkbox> -->
        </van-col>
        <van-col :span="10" >
            <!-- {{item.bandingUserPhone}} -->
                <van-field v-model="item.bandingUserPhone" type="tel" :readonly="item.bindingStatus=='已绑定'" style="font-size:0.85rem;padding-left:0.15rem" placeholder="填写手机号" maxlength='11'  />
        </van-col>
        <van-col :span="5">
        </van-col>
        </van-row>
      </van-checkbox-group>
        <!-- 添加 -->
        <van-row  
          type="flex"
          align="center"
          style="margin-left:1rem;height:2.5rem">
          <van-col :span="4">
            <van-checkbox-group  >
                <van-checkbox  shape="square" ref="checkboxes" @click="inputChangeChecked(customAdd)">
                </van-checkbox>
            </van-checkbox-group>
          </van-col>
          <van-col :span="6">
            <van-field
              v-model="customAdd.name"
              placeholder="填写姓名"
              size="large"
              style="font-size:0.85rem;padding-left:0.15rem"
            />
          </van-col>
          <van-col :span="10">
            <van-field
              maxlength='11' 
              v-model="customAdd.mobile"
              placeholder="填写手机号"
              size="large"
              style="font-size:0.85rem;padding-left:0.15rem"
            />
          </van-col>
          <van-col :span="1">
            <div class="operate">
              <div>
                <van-icon
                  name="add-o"
                  @click="inputChangeChecked(customAdd)"
                  color="#78849E"
                  size="1.2rem"
                />
              </div>
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="bind-list">
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            title=""
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
      </div>
    </div>
    <div class="save" v-show="hidShow">
      <!-- :disabled="(addPersonData.length-pNumber)<1&&delNewPersonData.length<1" -->
      <van-button round type="info" style="width:50%" @click="saveEditData"  v-show="!loading">保存</van-button>
      <van-button round type="info" style="width:50%" v-show="loading" >保存...</van-button> 
    </div>
  </div>
</template> 
<script>
import { isPhone } from '@/utils/validate.js'
import moment from "moment";

export default {
  data() {
    return {
      loading:false,
      columns: [],
      showPicker: false,
      addPersonData: [],
      notPersonData:[],
      addNewPersonData:[],
      delNewPersonData:[],
      personData: [],
      customAdd: {},
      radio: '',
      query: {},
      checkbox:[],
      checkboxed:[],
      radio3:[],
      docmHeight: document.documentElement.clientHeight, // 默认屏幕高度
      showHeight: document.documentElement.clientHeight, // 实时屏幕高度
      hidShow: true, // 显示或者隐藏footer
      pNumber:0
    }
  },
  watch: {
     
    showHeight: function () {
      if (this.docmHeight > this.showHeight) {
        this.hidShow = false
        // // 检测ios系统
        // let u = navigator.userAgent;
        // let isIOS =!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // // ios 软键盘弹出时 body的scrollTop 设为0
        // if(isIOS){
        //     document.body.scrollTop(0);
        //     console.log('苹果')
        // }
      } else {
        this.hidShow = true
      }
    },

  },
  mounted() {
    this.query = JSON.parse(sessionStorage.getItem('order_detail'))
    console.log('我是订单详情');
    console.log(this.query);
    this.getParentsList()
    this.getSubPersonList()
    
    console.log('详情',this.addPersonData)
    let vm = this
    // window.resize监听页面高度的变化
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight
      })()
    }
  },
  computed: {
    orderNumber() {
      return this.$route.query.orderNumber
    },
    userNumber() {
      return this.$route.query.userNumber
    },
    childrenId() {
      return this.$route.query.childrenId
    }
  },
  methods: { 
    listenEdPerson(val,index){
      // console.log('触发监听input');
      // console.log(val);
      this.addPersonData[index].new=true;
      let indexNote=-1;
      this.delNewPersonData.forEach((valSon,indexSon)=>{
        if(val.bandingUserId===valSon.bandingUserId){
            indexNote=indexSon
        }
      })
      if(indexNote<0){
        this.delNewPersonData.push(val);
      }else{
        this.delNewPersonData[indexNote]=val;
      }
    },
    getDateYMD(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    addPerson() {
      if (this.addPersonData.length + 1 > this.userNumber) {
        // this.$toast('订阅人数已超过限制')
        this.$toast('订阅人数仅限'+this.query.userNumber+'人')
        return
      }
      this.showPicker = true
    },
    inputChangeChecked(item) {
      if (!item.name) {
        this.$toast('请输入姓名')
        this.radio3=[];
        return false
      }
      if (!item.mobile) {
        this.$toast('请输入手机号')
        this.radio3=[];
        return false
      }
      if (!isPhone(item.mobile)) {
        this.$toast('手机号输入有误')
        this.radio3=[];
        return
      }
      let isExist
      let pIndex
      if (this.addPersonData.length > 0) {
          this.addPersonData.forEach(
          (data,index) =>{
            if(data.bandingUserPhone == item.mobile){
              pIndex=index;
              isExist=true;
              return false;
            }
          } 
        )
      }
      console.log('我是文本框手机号');
      console.log(item.mobile);
      console.log('我是已选中的手机号');
      console.log(this.addPersonData);
      if (isExist) {
        // this.$toast('手机号已存在，请勿重复添加')
        this.$toast('手机号与已订阅人员第'+(pIndex+1)+'行手机号重复')
        this.radio3 = []
        return false
      }
      if (this.addPersonData.length + 1 > this.userNumber) {
        // this.$toast('订阅人数已超过限制')
        this.$toast('订阅人数仅限'+this.query.userNumber+'人')
        this.radio3 = []
        return
      }else{
        let inputData={bandingUserName:item.name,bandingUserPhone:item.mobile} 
        this.addPersonData.push(inputData);
        this.addNewPersonData.push(inputData);
        this.radio3 = []
        this.customAdd.name="";
        this.customAdd.mobile="";
      }
    },
    handleChangeChecked(item) {
      //console.log('checked',this.userNumber)//监听复选框的变化
      let isExist
      if (this.addPersonData.length > 0) {
        isExist = this.addPersonData.some(
          (data) => data.bandingUserPhone == item.bandingUserPhone
        )
      }
      if (isExist) {
        this.$toast('手机号已存在，请勿重复添加')
        this.checkbox = []
        return false
      }
      if (this.addPersonData.length + 1 > this.userNumber) {
        // this.$toast('订阅人数已超过限制')
        this.$toast('订阅人数仅限'+this.query.userNumber+'人')
        this.checkbox = []
        return
      }else{
        this.notPersonData = this.notPersonData .filter(function(data) {
            return data != item
        });
        this.addPersonData.push(item);
        this.addPersonData[this.addPersonData.length-1].new='a'
        let result=this.delNewPersonData.indexOf(item);
        console.log(result)
        if(result>-1){
          // this.delNewPersonData= this.delNewPersonData.filter(function(data) {
          //   return data != item
          // });
        }else{
          this.addNewPersonData.push(item);
        }
      }
      //console.log('新增函数',this.addNewPersonData)
     // console.log('删除函数',this.delNewPersonData)
    },
    async getParentsList() {
      try {
        const { code, data } = await this.$https.getParentsList({
          // parentsId: JSON.parse(localStorage.getItem('userInfo'))
          //   .patriarchUserId,
          childId: this.childrenId,
        })
        if (code !== 200) {
          return false
        }
        this.columns = data.map((item) => item.name)
        this.personData = data.map((item) => ({
          id: item.id,
          name: item.name,
          mobile: item.mobile,
          schoolId: item.schoolId,
        }))
        let yb=data.filter((item)=>{
          return item.bindingStatus=='公众号已绑定'
        })
        console.log('我是已绑定的值');
        console.log(yb);
        this.getSubNotPersonList(yb)
      } catch (error) {}
    },
    async getSubPersonList() {
      try {
        const { code, data } = await this.$https.getSubPersonList({
          //schoolId: this.$store.state.pschoolId,
          orderNum: this.orderNumber })
        if (code !== 200) {
          return false
        }
        
        // data.forEach((val)=>{ 
        //   this.pNumber+=1 
        // }) 
        this.pNumber=data.length;
        this.addPersonData = data.filter((item) => {
          //if (item.bandingUserId !== this.$store.state.puserId) {
            item.disabled = false
            item.originalName = item.bandingUserName
            item.originalPhone = item.bandingUserPhone
            return item
          //}
        })
        // this.addPersonData = data.map((item) => ({
        //   bandingUserName: item.bandingUserName,
        //   bandingUserPhone: item.bandingUserPhone,
        //   bandingUserId: item.bandingUserId,
        //   bid: item.id,
        // }))
      } catch (error) {}
    },
    async getSubNotPersonList(b) {
      try {
        const { code, data } = await this.$https.getSubNotPersonList({
          orderNum: this.orderNumber,
        })
        if (code !== 200) {
          return false
        }
        if(data.length>0){
          this.notPersonData = data.filter((item) => {
              if(item.bandingUserId){
                item.disabled = false
                item.originalName = item.bandingUserName
                item.originalPhone = item.bandingUserPhone
                return item
              }
          })
          let zz=[];
          let indexSono=-1;
          data.forEach((val,index)=>{
            b.forEach((valSon,indexSon)=>{
              if(val.bandingUserPhone==valSon.bindingMobile){
                zz.push(val)  
                console.log('进来追加了');
              }
            })
          })  
          this.notPersonData.forEach((sv,indexSv)=>{
            zz.forEach((svSon,indexSon)=>{
              if(sv.bandingUserPhone==svSon.bandingUserPhone){
                this.notPersonData[indexSv].bindingStatus='已绑定'
              }
            })
          })
          console.log('我是notPersonData');
          console.log(this.notPersonData);
          // this.notPersonData = zz.filter((item) => {
          //     if(item.bandingUserId){
          //       item.disabled = false
          //       item.originalName = item.bandingUserName
          //       item.originalPhone = item.bandingUserPhone
          //       item.bindingStatus='已绑定'
          //       return item
          //     }
          // })
        }
      } catch (error) {}
    },
    onConfirm(v, i) {
      const obj = this.personData[i]
      let isExist
      if (this.addPersonData.length > 0) {
        isExist = this.addPersonData.every(
          (item) => item.bandingUserId == obj.id
        )
      }
      if (isExist) {
        this.$toast('人员已存在，请勿重复添加')
        return false
      }
      this.addBindPerson(obj)
      this.showPicker = false
    },
    async addBindPerson(item) {
      const { code, data, msg } = await this.$https.addParent({
        bandingUserId: item.id,
        bandingUserName: item.name,
        bandingUserPhone: item.mobile,
        schoolId: item.schoolId,
        subscribeNumber: this.orderNumber,
      })
      if (code !== 200) {
        this.$toast(`添加失败${msg}`)
        return false
      }
      // this.addPersonData.push(this.personItemData(item))
      this.getSubPersonList()
      this.radio = ''
      this.$toast('添加成功')
    },
    beforeClose(){

    },
    async delPersonData(item) { 
      this.$dialog.confirm({
        title: '温馨提示',
        message: '确认取消绑定此订阅人员吗？'
      }).then((active,done)=>{
        if(active){
          try {
            // this.notPersonData.push(item);
            this.addPersonData = this.addPersonData .filter(function(data) {
              return data.bandingUserPhone != item.bandingUserPhone
            });
            if(item.bandingUserId){
              this.notPersonData.push(item)
              this.notPersonData[this.notPersonData.length-1].disabled=false;
              this.notPersonData[this.notPersonData.length-1].originalName=item.bandingUserName;
              this.notPersonData[this.notPersonData.length-1].originalPhone=item.bandingUserPhone;
            }
            //  {
            //    disabled:false,
            //    bandingUserName:item.bandingUserName,
            //    bandingUserName:item.bandingUserPhone,
            //  }
            this.checkbox=[]
            this.$toast('取消订阅成功');
            let result=this.addNewPersonData.indexOf(item);
            console.log(result)
            if(result>-1){
              this.addNewPersonData= this.addNewPersonData.filter(function(data) {
                return data != item
              });
            }else{
              this.delNewPersonData.push(item);
            }
              //console.log('新增',this.addNewPersonData)
              //console.log('删除',this.delNewPersonData)
          } catch (error) {
            console.log(error)
          }
        }
        
      })
      
      // return;
      // try {
      //   this.notPersonData.push(item);
      //   this.addPersonData = this.addPersonData .filter(function(data) {
      //     return data != item
      //   });
      //   this.checkbox=[]
      //   this.$toast('删除成功');
      //   let result=this.addNewPersonData.indexOf(item);
      //   console.log(result)
      //   if(result>-1){
      //     this.addNewPersonData= this.addNewPersonData.filter(function(data) {
      //       return data != item
      //     });
      //   }else{
      //     this.delNewPersonData.push(item);
      //   }
      //     //console.log('新增',this.addNewPersonData)
      //     //console.log('删除',this.delNewPersonData)
      // } catch (error) {
      //   console.log(error)
      // }
    },
    async saveEditData(){  
      let c=this.addPersonData;
      // this.loading=true;
      console.log(this.addPersonData);
      let personData=[] 
      let dyPerson=false;
      this.addPersonData.forEach((val)=>{ 
        if (!isPhone(val.bandingUserPhone)) {
          this.$toast('已订阅人员手机号输入有误') 
          dyPerson=true;
          return
        }
        if(!val.bandingUserId||val.new){
          personData.push(val)
        }
      }) 
      if(dyPerson){
        return;
      }
      let t=true;
      for(let i=0;i<c.length;i++){
        for(let j=i+1;j<c.length;j++){
           if(c[i].bandingUserPhone===c[j].bandingUserPhone){
              this.$toast('手机号有重复')
              console.log('进来了');
              t=false; 
            //  c.splice(j,1)
             break;
            //  j--;
            //  return false;
           }else{
             console.log('出去了');
           }
        }  
      }
      if(!t){
        return false;
      }
      // this.addPersonData.forEach((valSon,index)=>{ 
      // })
      // if(personData.length<0&&removeSubscriberList.length<0){
      //     console.log('没有修改的内容');
      // }
      // console.log('我是需要追加的值');
      // console.log(personData);
      // console.log('我是需要删除的值');
      // console.log(this.delNewPersonData);
      // return;
      const { code, data, msg } = await this.$https.saveEditData({
        addSubscriberList:personData,
        removeSubscriberList: this.delNewPersonData,
        orderNum: this.orderNumber,
      })
      if (code !== 200) {
        this.loading=false;
        this.$toast(`保存失败${msg}`)
        return false
      }else{
        this.$toast('保存成功')
        this.addNewPersonData=[]
        this.delNewPersonData=[]
        this.loading=false;
        this.$router.go(-1);
      }
    },
    personItemData(obj) {
      if (Object.keys(obj).length <= 0) {
        return {}
      }
      return {
        bandingUserName: obj.name,
        bandingUserId: obj.id,
        schoolId: obj.schoolId,
        bandingUserPhone: obj.mobile,
        disabled: obj.disabled,
        originalName: obj.name,
        originalPhone: obj.mobile,
      }
    },
    PaddCustomPerson(){
      if (!this.customAdd.name) {
        this.$toast('请输入姓名')
        return false
      }
      if (!this.customAdd.mobile) {
        this.$toast('请输入手机号')
        return false
      }
      if (!isPhone(this.customAdd.mobile)) {
        this.$toast('手机号输入有误')
        return
      }
      let isExist
      if (this.notPersonData.length > 0) {
        isExist = this.notPersonData.some(
          (data) => data.bandingUserPhone == this.customAdd.mobile
        )
      }
      if (isExist) {
        this.$toast('手机号已存在，请勿重复添加')
        return false
      }
      let tempNotPersonData={bandingUserName:this.customAdd.name,bandingUserPhone:this.customAdd.mobile};
      this.notPersonData.push(tempNotPersonData);
      console.log('用户添加值',tempNotPersonData);
      this.customAdd={};
    },
    addCustomPerson() {
      // if (
      //   this.addPersonData.length + 1 >=
      //   this.$store.state.vipData[0].userNumber
      // ) {
      //   this.$toast('套餐人员已超过限制')
      //   return
      // }
      if (!this.customAdd.name) {
        this.$toast('请输入姓名')
        return false
      }
      if (!this.customAdd.mobile) {
        this.$toast('请输入手机号')
        return false
      }
      if (!isPhone(this.customAdd.mobile)) {
        this.$toast('手机号输入有误')
        return
      }
      if (this.addPersonData.length + 1 >= this.userNumber) {
        this.$toast('订阅人数仅限'+this.query.userNumber+'人')
        return
      }
      this.addBindPerson({
        id: '',
        ...this.customAdd,
        schoolId: this.$store.state.schoolId,
      })
      this.customAdd = {}
      // this.addPersonData.push(
      //   this.personItemData({
      //     disabled: true,
      //     bandingUserName: '',
      //     bandingUserPhone: '',
      //   })
      // )
    },
    editPerson(item) {
      // console.log(item)
      item.disabled = true
    },
    closeEdit(item) {
      item.disabled = false
      item.bandingUserName = item.originalName
      item.bandingUserPhone = item.originalPhone
    },
    async confirmEdit(item) {
      const { data, code } = await this.$https.editBindPerson({
        bandingUserId: item.bandingUserId,
        bandingUserName: item.bandingUserName,
        bandingUserPhone: item.bandingUserPhone,
        id: item.id,
        schoolId: item.schoolId,
        subscribeNumber: this.orderNumber,
      })
      if (code !== 200) {
        item.disabled = false
        item.bandingUserName = item.originalName
        item.bandingUserPhone = item.originalPhone
        this.$toast('修改失败')
        return
      }
      item.disabled = false
      item.originalName = item.bandingUserName
      item.originalPhone = item.bandingUserPhone
      this.$toast('修改成功')
    },
    // async editConfirmPerson() {
    //   await this.$https.editBindPerson({
    //     bandingUserId:
    //   })
    // },
  },
}
</script>
<style lang="scss">
  .bService{
    transform: translate(-1rem,0);
  }
  .bPhone{
    transform: translate(-0.7rem,0);
  }
</style>
<style lang="scss" scoped>
.big{
  padding-top:0.25rem;
  margin-bottom: 7rem;
}
/*iPhone6/7/8*/
  @media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (-webkit-device-pixel-ratio: 2) {
    .big{
      padding-top:0.25rem;
      margin-bottom: 6rem;
      padding-bottom: 5rem;
    }
  }
  /*iPhone6/7/8 Plus*/
  @media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (-webkit-device-pixel-ratio: 3) {
    .big{
      padding-top:0.25rem;
      margin-bottom: 6rem;
      padding-bottom: 5rem;
    }
  }
  /*iPhone X*/
  @media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .big{
      padding-top:0.25rem;
      margin-bottom: 6rem;
      padding-bottom: 5rem;
    }
  }
  /* 判断iphone5 */
  @media only screen and (min-device-width: 320px) and (max-device-height: 568px) {
    .big{
      padding-top:0.25rem;
      margin-bottom: 6rem;
      padding-bottom: 5rem;
    }
  }
  // iPhoneXR iPhone11
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    .big{
        padding-top:0.25rem;
        margin-bottom: 6rem;
        padding-bottom: 5rem;
      }
  }
  // iPhone11Pro
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .big{
        padding-top:0.25rem;
        margin-bottom: 6rem;
        padding-bottom: 5rem;
      }
  }
  // iPhoneXSMax
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .big{
        padding-top:0.25rem;
        margin-bottom: 6rem;
        padding-bottom: 5rem;
      }
  }
.card {
  .card-title {
    color: #1A1A1A;
    font-size: 0.88rem;
    padding: 1.06rem;
    /* padding-top: 0; */
  }
  .bind-list {
    padding: 0.3rem 1.06rem;

    color: #454f63;
    .bind-list-title {
      font-size: 0.85rem;
      color: #666666;
      padding: 0 16px;
    }
    .operate {
    //   height: 48px;
      background: #fff;
      text-align: center;
      line-height: 48px;
    //   margin-top:.4rem;
      img {
        width: 1rem;
        height: 1rem;
      }
    }
    .bind-list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1rem;
      &.bind-mb {
        margin-bottom: 1.19rem;
      }
      .bind-t-1 {
        width: 5rem;
        text-align: left;
        font-size: 0.85rem;
        color: #454f63;;
      }
      .bind-t-2 {
        width: 8rem;
        text-align: left;
        font-size: 0.85rem;
        color: #454f63;
      }
      .bind-t-3 {
        /* width: 5rem; */
        text-align: center;
        width: 3.31rem;

        img {
          width: 1.05rem;
          height: 1.05rem;
        }
        &.add {
          border: 0.06rem solid #e2bd78;
          border-radius: 0.75rem;
          width: 3.31rem;
          height: 1.25rem;
          text-align: center;
          line-height: 1.25rem;
          font-size: 0.88rem;
          color: #c28f22;
        }
      }
    }
  }
}
.card {
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #fff;
  margin: 1rem 0.5rem;
  border-radius: 0.75rem;
  padding-bottom: 2rem;

  .title {
    color: #1A1A1A;
    font-size: 0.88rem;
    padding: 1.06rem;
    padding-bottom: 0.5rem;
    /* border-bottom: 1px solid rgba(244, 244, 246, 0.99); */
  }

  .list {
    .list-item {
      padding: 0.3rem 1.6rem;
      color: #454f63;
      font-size: 0.875rem;
      display: flex;
      align-items: center;

      /* justify-content: space-between; */
      > span:first-child {
        display: inline-block;
        width: 4.5rem;
        text-align: left;
        color: #666666;
        font-size: 0.85rem;
      }

      > span:last-child {
        font-size: 0.85rem;
      }
      .dueTime{
        font-size:0.75rem;
        color:#666666;
        position:absolute;
        padding-top:1.5rem;
      }
    }
  }
}
.card {
  .card-title {
    color: #1A1A1A;
    font-size: 0.88rem;
    padding: 1.06rem;
    padding-bottom: 0.5rem;
    /* padding-top: 0; */
    .orderName{
      height:0.5rem; 
      padding:0.1rem;
      background:#37A5DA;
      margin-right:0.2rem;
    }
  }
  .bind-list {
    padding: 0.3rem 0.86rem;

    color: #454f63;
    .bind-list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1rem;
      &.bind-mb {
        margin-bottom: 1rem;
      }
      .bind-t-1 {
        width: 8rem;
        text-align: left;
        font-size: 0.85rem;
        color: #454f63;
        ::v-deep .van-cell {
          padding: 0;
        }
      }
      .bind-t-2 {
        width: 8rem;
        text-align: left;
        font-size: 0.85rem;
        color: #454f63;
        ::v-deep .van-cell {
          padding: 0;
        }
      }
      .bind-t-3 {
        /* width: 5rem; */
        text-align: center;
        width: 3.31rem;
        img {
          width: 1.05rem;
          height: 1.05rem;
        }
        .add {
          border: 0.06rem solid #e2bd78;
          border-radius: 0.75rem;
          width: 3.31rem;
          height: 1.25rem;
          text-align: center;
          line-height: 1.25rem;
          font-size: 0.88rem;
          color: #c28f22;
        }
      }
    }
  }
}
.person {
  background: #fff;
  padding: 0.5rem;
  margin-top: 0.4rem;
  .title {
    margin-bottom: 0.6rem;
    color: #78849e;
    font-size: 0.63rem;
  }
}
.save{
  position: fixed;
  bottom: 0;
  left: 0;
  background: white;
  height: 6rem;
  width: 100%;
  text-align: center;
  line-height: 6rem;
  box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.1);
}
</style>
